import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const EmployeeCardPage = lazy(() => import('@/pages/hr/EmployeeCardPage'));
const OrgChartPage = lazy(() => import('@/pages/hr/OrgChartPage'));
const LeavePolicyPage = lazy(() => import('@/pages/hr/LeavePolicyPage'));
const LeaveStatusPage = lazy(() => import('@/pages/hr/LeaveStatusPage'));
const WorkParticipationPage = lazy(() => import('@/pages/hr/WorkParticipationPage'));

/**
 * 인사관리 모듈 라우트.
 * 사용자관리 · 조직관리는 기존 경로(settingsRoutes)를 그대로 쓰고 메뉴 위치만 인사관리 하위다.
 */
const hrRoutes = [
  <Route
    key="hr-employees"
    path="hr/employees"
    element={<PrivateRoute menuCode={MENU.HR_EMPLOYEE}><EmployeeCardPage /></PrivateRoute>}
  />,
  <Route
    key="hr-orgchart"
    path="hr/orgchart"
    element={<PrivateRoute menuCode={MENU.HR_ORGCHART}><OrgChartPage /></PrivateRoute>}
  />,
  <Route
    key="hr-work-participation"
    path="hr/work-participation"
    element={<PrivateRoute menuCode={MENU.HR_WORK_PARTICIPATION}><WorkParticipationPage /></PrivateRoute>}
  />,
  <Route
    key="hr-leave-status"
    path="hr/leave-status"
    element={<PrivateRoute menuCode={MENU.HR_LEAVE_STATUS}><LeaveStatusPage /></PrivateRoute>}
  />,
  <Route
    key="hr-leave-policy"
    path="hr/leave-policy"
    element={<PrivateRoute menuCode={MENU.HR_LEAVE_POLICY}><LeavePolicyPage /></PrivateRoute>}
  />,
];

export default hrRoutes;
